import { createRequestTypes, generateRequestActions } from 'utils/actionHelpers/actionHelpers'

export const GOOGLE_PLACE_COORDS = createRequestTypes('GOOGLE_PLACE_COORDS')

export const googlePlaceCoords = generateRequestActions(GOOGLE_PLACE_COORDS)
